import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { lsGet, lsSet } from "@/lib/storage";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(lsGet("afrodite_cookie") !== "true");
  }, []);
  if (!show) return null;
  const accept = () => { setShow(false); lsSet("afrodite_cookie", "true"); };
  return (
    <div className="fixed bottom-0 inset-x-0 z-50 p-3 sm:p-4 pb-20 sm:pb-4 pointer-events-none">
      <div className="max-w-4xl mx-auto glass border border-[#D4AF37]/20 rounded-xl p-4 sm:p-5 flex flex-col sm:flex-row items-center gap-3 sm:gap-4 shadow-2xl pointer-events-auto">
        <p className="text-xs sm:text-sm text-[#A39E9B] flex-1 leading-relaxed">
          Utilizziamo cookie tecnici per garantire la migliore esperienza sul sito. Continuando la navigazione accetti la nostra{" "}
          <Link to="/info" className="text-[#D4AF37] underline underline-offset-2">privacy policy</Link>.
        </p>
        <button
          data-testid="cookie-accept-btn"
          onClick={accept}
          className="shrink-0 px-6 py-2.5 rounded-full bg-[#7A1426] hover:bg-[#941B30] text-[#FBF8F5] text-sm font-semibold transition-colors border border-[#D4AF37]/30"
        >
          Accetto
        </button>
      </div>
    </div>
  );
}
